import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { GestionPrecioMasivoDetalle } from './components/GestionPrecioMasivoDetalle';

export default function GestionPrecioMasivoDet() {
    return (
        <MainContent
            component={<GestionPrecioMasivoDetalle />}
            titulo='Cambios de precios masivos'
            noBackground
            tableMaxWidth
        />
    );

};